import { render, staticRenderFns } from "./InquiryFormHome.vue?vue&type=template&id=5afce51c"
import script from "./InquiryFormHome.vue?vue&type=script&lang=js"
export * from "./InquiryFormHome.vue?vue&type=script&lang=js"
import style0 from "./InquiryFormHome.vue?vue&type=style&index=0&id=5afce51c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports